import { useDispatch, useSelector } from 'react-redux';
import {
	scheduleDvrRecording,
	fetchDvrRecordings,
	scheduleNpvrRecording,
	fetchNpvrRecordings
} from 'store/actions';

export const useProgramRecordings = (programId) => {
	const dispatch = useDispatch();
	const { data: recordingsDvr, isLoaded: areDvrRecordingsLoaded } = useSelector(
		({ recordingsDvr }) => recordingsDvr
	);
	const {
		data: recordingsNpvr,
		isLoaded: areNpvrRecordingsLoaded
	} = useSelector(({ recordingsNpvr }) => recordingsNpvr);

	const { selectedDevice, data: stbDevices } = useSelector(
		({ devices }) => devices
	);

	const deviceForRecording = selectedDevice || stbDevices[0]?.id;

	const handleScheduleDvrRecordings = () => {
		if (deviceForRecording) {
			scheduleDvrRecording(programId, deviceForRecording, () =>
				fetchDvrRecordings(deviceForRecording)(dispatch)
			)(dispatch);
		}
	};

	const handleScheduleNpvrRecordings = () => {
		scheduleNpvrRecording(programId, () => fetchNpvrRecordings()(dispatch))(
			dispatch
		);
	};

	const isDvrProgramRecorded = recordingsDvr.find(
		({ programUuid }) => programUuid === programId
	);

	const isNpvrProgramRecorded = recordingsNpvr.find(
		({ program_uuid }) => program_uuid === programId
	);

	const isRecorded = isDvrProgramRecorded || isNpvrProgramRecorded;
	const isLoading = !areDvrRecordingsLoaded || !areNpvrRecordingsLoaded;

	return {
		scheduleDvrRecordings: handleScheduleDvrRecordings,
		scheduleNpvrRecordings: handleScheduleNpvrRecordings,
		isLoading,
		isRecorded
	};
};
